export const ENTITIES_SAVE_REQUESTED = 'ENTITIES_SAVE_REQUESTED';
export const ENTITIES_SAVE_SUCCEEDED = 'ENTITIES_SAVE_SUCCEEDED';
export const ENTITIES_SAVE_FAILED = 'ENTITIES_SAVE_FAILED';

export const ENTITIES_UPDATE = 'ENTITIES_UPDATE';
export const ENTITY_UPDATE = 'ENTITY_UPDATE';
export const ENTITIES_VALUE_UPDATE = 'ENTITIES_VALUE_UPDATE';
export const ENTITY_VALUE_UPDATE = 'ENTITY_VALUE_UPDATE';
export const ENTITY_REMOVE = 'ENTITY_REMOVE';
export const ENTITIES_REMOVE = 'ENTITIES_REMOVE';
export const ENTITIES_UPDATES_PURGE = 'ENTITIES_UPDATES_PURGE';

export const ENTITY_SET = 'ENTITY_SET';
export const ENTITIES_SET = 'ENTITIES_SET';
export const ENTITIES_MERGE = 'ENTITIES_MERGE';
export const ENTITY_BULK_DELETE = 'ENTITY_BULK_DELETE';
export const ENTITIES_ERRORS_SET = 'ENTITIES_ERRORS_SET';
